import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/anonyme-bewerbung-ein-schritt-in-richtung-chancengleichheit.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')